import React from 'react';
import { Link } from 'react-router-dom';
import { footerColumns } from '../../data/navigation';
import { contactDetails } from '../../data/company';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { Logo } from '../brand/Logo';
import { Button } from '../ui/Button';
export function Footer() {
  const {
    openPanel
  } = useCookieConsent();
  return <footer className="bg-midnight-950 text-white" data-id="element-383" data-mp="npsud6xi6ue">
      <div className="container-page py-16 md:py-20" data-id="element-384" data-mp="pkdrri79yyh">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-385" data-mp="3s25bma8ijfgy">
          <div className="lg:col-span-4" data-id="element-386" data-mp="3s1c9jmki1e55">
            <Logo data-id="element-387" data-mp="3n32fxgefalln" />
            <p className="mt-6 max-w-sm leading-relaxed text-white/65" data-id="element-388" data-mp="3n4ly5cjn36q2">
              A research-led executive search and recruitment firm connecting organisations with exceptional professionals and leaders.
            </p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-389" data-mp="3e2ckwewzkz8z">
              <Button to="/employers" size="sm" data-id="element-390" data-mp="3939jr5k4nd6a">
                Hire Talent
              </Button>
              <Button to="/jobs" size="sm" variant="outlineLight" data-id="element-391" data-mp="2kcl3va4mcnwp">
                Find Jobs
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8" data-id="element-392" data-mp="2p54i89b4rn2k">
            {footerColumns.map(col => <div key={col.title} data-id="element-393" data-mp="2gbj32ov203sm">
                <h2 className="text-sm font-medium text-gold-300" data-id="element-394" data-mp="2gckqlst9air8">{col.title}</h2>
                <ul className="mt-4 space-y-3" data-id="element-395" data-mp="340khqtuhcb6c">
                  {col.links.map(l => <li key={l.to} data-id="element-396" data-mp="382fj1yceuok4">
                      <Link to={l.to} className="text-sm text-white/70 transition-colors duration-150 hover:text-white" data-id="element-397" data-mp="381e6fpfqxu0a">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-14 grid gap-6 border-t border-white/10 pt-10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-398" data-mp="1im6bq6dlflnp">
          {contactDetails.map(c => <div key={c.label} data-id="element-399" data-mp="13khl3xhap2so">
              <p className="text-xs text-white/50" data-id="element-400" data-mp="13jof4yq5uhbl">{c.label}</p>
              <p className="mt-1 text-sm text-white/80" data-id="element-401" data-mp="zje7lhmpzium">{c.value}</p>
            </div>)}
          <div data-id="element-402" data-mp="us5wmh5qrpfc">
            <p className="text-xs text-white/50" data-id="element-403" data-mp="urmeazc6iz0s">Social</p>
            <p className="mt-1 text-sm text-white/80" data-id="element-404" data-mp="uq2x96ip8jxy">[Profiles to be added]</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-white/55 md:flex-row md:items-center md:justify-between" data-id="element-405" data-mp="ku8abz7g02pd">
          <p data-id="element-406" data-mp="fudjtwrkxf4u">© 2026 Corventa Talent Search. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-407" data-mp="bt1pjdxrg5qb">
            <Link to="/legal/privacy" className="hover:text-white" data-id="element-408" data-mp="bvnxheokcn92">
              Privacy
            </Link>
            <Link to="/legal/terms" className="hover:text-white" data-id="element-409" data-mp="6wtfgeyf72q0">
              Terms
            </Link>
            <Link to="/legal/accessibility" className="hover:text-white" data-id="element-410" data-mp="2658b96oa64wv">
              Accessibility
            </Link>
            <button type="button" onClick={openPanel} className="hover:text-white" data-id="element-411" data-mp="28sitj4k2q7ht">
              Cookie preferences
            </button>
          </div>
        </div>
      </div>
    </footer>;
}